import React, {Component} from 'react';
import Wrapper from "../Wrapper";
import {Link} from "react-router-dom";
import axios from 'axios';
import {Faq} from "../../classes/faq";
import Paginator from "../components/Paginator";
import Deleter from "../components/Deleter";
import {connect} from "react-redux";
import {User} from "../../classes/user";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Faqs extends Component<{ user: User }> {
    state = {
        faqs: []
    }
    page = 1;
    last_page = 0;

    componentDidMount = async () => {
        const response = await axios.get(`faqs?page=${this.page}`);
        this.setState({
            faqs: response.data.data
        })

        this.last_page = response.data.meta.last_page;
    }

    handleDelete = async (id: number) => {
        this.setState({
            faqs: this.state.faqs.filter((p: Faq) => p.id !== id)
        })
    }

    handlePageChange = async (page: number) => {
        this.page = page;
        await this.componentDidMount();
    }

    actions = (id: number) => {
        if (this.props.user.canEdit('faqs')) {
            return (
                <div className="btn-group mr-2">
                    <Link to={`/faqs/${id}/edit`}
                          className="btn btn-sm btn-outline-secondary">
                              <FontAwesomeIcon icon={faEdit} color="#007bff" />
                    </Link>
                    <Deleter id={id} endpoint={'faqs'}
                             handleDelete={this.handleDelete}/>
                </div>
            )
        }
    }

    render() {
        let addButton = null;

        if (this.props.user.canEdit('faqs')) {
            addButton = (
                <div
                    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <Link to={'/faqs/create'} className="btn btn-sm btn-success">Incluir</Link>
                    </div>
                </div>
            )
        }

        return (
            <Wrapper>
                <h4>Preguntas Frecuentes</h4>
                {addButton}
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Pregunta</th>
                            <th>Respuesta</th>
                            <th>Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.faqs.map(
                            (faq: Faq) => {
                                return (
                                    <tr key={faq.id}>
                                        <td>{faq.id}</td>
                                        <td>{faq.question}</td>
                                        <td>{faq.answer}</td>
                                        <td>{this.actions(faq.id)}</td>
                                    </tr>
                                )
                            }
                        )}
                        </tbody>
                    </table>
                </div>

                <Paginator lastPage={this.last_page} handlePageChange={this.handlePageChange}/>
            </Wrapper>
        );
    }
}

// @ts-ignore
export default connect(state => ({user: state.user}))(Faqs);